export enum MissionNameEnum {
  EARLY_BIRD = 'EARLY_BIRD',
  WEEKLY_MULTIPLIER = 'WEEKLY_MULTIPLIER',
  TWITTER_FOLLOW = 'TWITTER_FOLLOW',
  TELEGRAM_JOIN = 'TELEGRAM_JOIN',
  DEPOSIT_ANY_AMOUNT_ETH = 'DEPOSIT_ANY_AMOUNT_ETH',
  REFERRAL_DEPOSIT_ANY_ETH = 'REFERRAL_DEPOSIT_ANY_ETH',
  REFERRAL_DEPOSIT_MORE_THAN_1_ETH = 'REFERRAL_DEPOSIT_MORE_THAN_1_ETH',
  EACH_REFERRAL_DEPOSIT_MORE_THAN_0_POINT_1_ETH = 'EACH_REFERRAL_DEPOSIT_MORE_THAN_0_POINT_1_ETH',
  MAINTAIN_PLUS_1_ETH_TO_TGE = 'MAINTAIN_PLUS_1_ETH_TO_TGE',
  MAINTAIN_PLUS_5_ETH_TO_TGE = 'MAINTAIN_PLUS_5_ETH_TO_TGE',
  MAINTAIN_MORE_THAN_5_ETH_TO_TGE = 'MAINTAIN_MORE_THAN_5_ETH_TO_TGE',
  MAINTAIN_PLUS_3000_USDT_TO_TGE = 'MAINTAIN_PLUS_3000_USDT_TO_TGE',
  MAINTAIN_PLUS_15000_USDT_TO_TGE = 'MAINTAIN_PLUS_15000_USDT_TO_TGE',
  MAINTAIN_MORE_THAN_15000_USDT_TO_TGE = 'MAINTAIN_MORE_THAN_15000_USDT_TO_TGE',
}

export enum MissionCategoryEnum {
  GENERAL = 'GENERAL',
  ETH = 'ETH',
  STABLECOIN = 'STABLECOIN',
}
